<template>
  <div class="NewList_society">
    <div class="Society_box">
      <!-- <div class="Society_box_div"> -->
      <transition-group name="list" tag="div" class="Society_box_div">
        <div
          class="Society_box_content list-item"
          v-for="(item, index) in dataList"
          @click="toArticles(item.id)"
          :key="index"
        >
          <div class="Society_img_box">
            <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />

            <div class="title">
              <span class="p">{{ item.title }}</span>
            </div>
          </div>
          <div class="Society_text">
            <div
              class="Society_text_content"
              v-html="$options.filters.formatTime(item.content, language,60, 90)"
            ></div>
            <div class="more">
              <div class="date">{{ item.releaseTime }}</div>
              <div>{{ $t("NewList.LearnMore") }}></div>
            </div>
          </div>
        </div>
      </transition-group>
      <!-- </div> -->
      <div style="height: 60px" v-if="moreActive">
        <div class="more_new" @click="moreNewFun()" v-if="dataList.length > 0 && !moreShowBoolen">
          {{ $t("NewList.More") }}
        </div>
        <div  v-if="dataList.length == 0" class="noData">{{ $t("NewList.NoData") }}</div>
      </div>

      <div v-if="!moreActive" style="height: 60px">
        <NewLoading></NewLoading>
      </div>
    </div>
    <div class="Society_vedio_box" v-if="videoList.length > 0">
      <div class="tit_box">
        <div class="tit">{{ $t("NewList.Video") }}</div>
      </div>
      <div class="bottom">
        <div class="bottom_box">
          <div
            class="bottom_box_content"
            v-for="(item, index) in videoList.slice(0, 3)"
            :key="index"
          >
            <div class="bottom_box_content_img_box">
              <video
                controls
                class="my-video"
                :poster="`${GLOBAL.imageUrl}${item.cover}`"
              >
                <source
                  :src="`${GLOBAL.url}/file/${item.filePath}`"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="date">{{ item.createTime.slice(0, 10) }}</div>
            <div class="content_test">
              <p>{{ item.title }}</p>
              <div>{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
import bus from "@/bus";
export default {
  mixins: [mapMixin],
  props: [
    "activeType",
    "dataList",
    "videoList",
    "moreShowBoolen",
    "moreActive",
  ],
  watch: {
    dataList(val) {},
  },
  data() {
    return {
      // moreActive:true,
    };
  },

  components: {
    NewLoading: () =>
      import("@/components/PublicComponents/NewLoading/NewLoading.vue"),
  },
  filters: {
    formatTime: function (value, language,zhNum, enNum) {
      var msg = value.replace(/<\/?[^>]*>/g, " "); //去除HTML Tag
      msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
      msg = msg.replace(/&nbsp;/gi, ""); //去掉npsp
      msg = msg.replace(/\s+/g, " "); //去掉npsp
      // return msg.slice(0, 90);
      if (language == "zh") {
        return msg.slice(0, zhNum).concat("......");
      } else {
        return msg.slice(0, enNum).concat("...");
      }
    },
  },
  methods: {
    moreNewFun() {
      // this.moreActive = false
      this.dataListArray = [];
      bus.$emit("moreNew");
      // setTimeout(()=>{
      //   console.log(this.dataList)
      //   this.dataList.newsList = this.dataList.newsList.concat(this.dataList.newsList)
      //   this.moreActive = true
      // },3000)
    },
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
  .NewList_society {
    width: 100%;

    .Society_title {
      display: inline-block;
      margin: 40px 0 30px;
      color: #fff;
      padding: 10px 30px;
      background: #439f38;
    }
  }
  .Society_box {
    width: 1200px;
    margin: 20px auto 0;
    margin-bottom: 40px;

    .Society_box_div {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;

      .Society_box_content:nth-child(3n-1) {
        margin: 0 21px;
      }
      .Society_box_content:hover .p {
        background-size: 100% 2px !important;
      }
      .Society_box_content {
        width: 386px;
        height: 617px;
        cursor: pointer;
        margin-bottom: 20px;
        &:hover .Society_text {
          background: #00689d;
          color: #fff;
          transition: 0.8s ease;
        }

        &:hover img {
          transition: 0.8s ease;
          transform: scale(1.2, 1.2);
        }
        &:hover .Society_text .more,
        &:hover .Society_text .more .date {
          color: #fff;
          transition: 0.8s ease;
        }

        &:hover .Society_img_box::after {
          z-index: 33 !important;
          opacity: 1 !important;
          transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        }
        .Society_img_box {
          position: relative;
          width: 386px;
          height: 446px;
          overflow: hidden;
          &::after {
            box-sizing: border-box;
            word-wrap: break-word;
            content: "";
            opacity: 0;
            background-image: linear-gradient(to bottom, transparent, #000);
            transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }
          &::before {
            content: "";
            display: block;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
            transition: 0.8s ease;
          }

          .title {
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin-top: 7px;
            font-size: 31px;
            color: #fff;
            margin-bottom: 8px;
            padding: 20px;
            position: absolute;
            bottom: 0;
            color: #fff;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 15px;
            z-index: 99;
            .p {
              background-image: linear-gradient(#fff, #fff);
              background-position: left bottom;
              background-repeat: no-repeat;
              transition: background-size 0.2s
                cubic-bezier(0.55, 0.085, 0.68, 0.53);
              text-decoration: none;
              background-size: 0px 2px;
            }
          }
        }
        .Society_text {
          width: 100%;
          height: 170px;
          // border-bottom-left-radius: 4px;
          // border-bottom-right-radius: 4px;
          border-radius: 4px;
          color: #333333;
          background: #fff;

          .Society_text_content {
            // height: auto;
            // display: -webkit-box;
            // overflow: hidden; /*超出隐藏*/
            // text-overflow: ellipsis; /*隐藏后添加省略号*/
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 3; //想显示多少行

            letter-spacing: 0px;
            padding: 20px 20px 0 20px;
            line-height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-bottom: 30px;
          }
          .more {
            padding: 0 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding-left: 20px;
            // width: 80px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #006eff;
            line-height: 22px;
            .date {
              color: rgba(0, 110, 255, 1);
              font-size: 24px;
              font-weight: 600;
              font-family: arial;
            }
          }
        }
      }
    }
  }
  .more_new {
    display: flex;
    flex-direction: row;
    padding: 10px 30px;
    color: #fff;
    border-radius: 5px;
    background: #00689d;
    width: fit-content;
    justify-content: center;
    align-items: center;
    margin: auto;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
  .noData {
    line-height: 60px;
    text-align: center;
    color: #999;
  }
  .Society_vedio_box {
    width: 100%;
    .tit_box {
      width: 100%;
      height: 229px;
      background: rgba(10, 16, 75, 1);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .tit {
        color: #fff;
        background: rgba(0, 87, 217, 1);
        width: 440px;
        height: 80px;
        font-size: 40px;
        line-height: 80px;
        text-align: center;
      }
    }
    .bottom {
      width: 1200px;
      margin: 50px auto 0px;
      padding-bottom: 40px;

      .bottom_box {
        display: flex;
        flex-direction: row;

        margin-right: 10px;
        height: 600px;

        .bottom_box_content:first-child {
          background: rgb(0, 104, 157);
        }
        .bottom_box_content:nth-child(2) {
          background: rgba(74, 159, 65, 1);
        }
        .bottom_box_content:last-child {
          background: rgb(252, 195, 11);
        }
        .bottom_box_content {
          cursor: pointer;
          width: 400px;
          height: 100%;
          border-radius: 4px;
          &:hover img {
            opacity: 0.5;
            transition: 0.8s ease;
            transform: scale(1.2, 1.2);
          }
          // box-shadow: 0px 6px 5px #ccc;
          .bottom_box_content_img_box {
            height: 264px;
            padding: 10px;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            .my-video {
              width: 100%;
              object-fit: cover;
            }
          }
          // img {
          //   object-fit: cover;
          //   width: 100%;
          //   height: 100%;
          //   padding: 18px;
          //   transition: 0.8s ease;
          // }
          video {
            width: 100%;
            height: 100%;
          }
          .date {
            margin-top: 20px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;

            border: 1px solid #fff;
            border-left: none;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            padding: 0 20px;
            overflow: hidden;
            p {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;
            }
            div {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 5;
              margin-top: 14px;
              font-size: 16px;
              color: #fff;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
  .list-item {
    // display: inline-block;
    // margin-right: 10px;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .NewList_society {
    width: 100%;

    .Society_title {
      display: inline-block;
      margin: 40px 0 30px;
      color: #fff;
      padding: 10px 30px;
      background: #439f38;
    }
  }
  .Society_box {
    width: 1200px;
    margin: 20px auto 0;
    margin-bottom: 40px;

    .Society_box_div {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;

      .Society_box_content:nth-child(3n-1) {
        margin: 0 21px;
      }
      .Society_box_content:hover .p {
        background-size: 100% 2px !important;
      }
      .Society_box_content {
        width: 386px;
        height: 617px;
        cursor: pointer;
        margin-bottom: 20px;
        &:hover .Society_text {
          background: #00689d;
          color: #fff;
          transition: 0.8s ease;
        }

        &:hover img {
          transition: 0.8s ease;
          transform: scale(1.2, 1.2);
        }
        &:hover .Society_text .more,
        &:hover .Society_text .more .date {
          color: #fff;
          transition: 0.8s ease;
        }

        &:hover .Society_img_box::after {
          z-index: 33 !important;
          opacity: 1 !important;
          transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
        }
        .Society_img_box {
          position: relative;
          width: 386px;
          height: 446px;
          overflow: hidden;
          &::after {
            box-sizing: border-box;
            word-wrap: break-word;
            content: "";
            opacity: 0;
            background-image: linear-gradient(to bottom, transparent, #000);
            transition: opacity 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }
          &::before {
            content: "";
            display: block;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
            transition: 0.8s ease;
          }

          .title {
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin-top: 7px;
            font-size: 31px;
            color: #fff;
            margin-bottom: 8px;
            padding: 20px;
            position: absolute;
            bottom: 0;
            color: #fff;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 15px;
            z-index: 99;
            .p {
              background-image: linear-gradient(#fff, #fff);
              background-position: left bottom;
              background-repeat: no-repeat;
              transition: background-size 0.2s
                cubic-bezier(0.55, 0.085, 0.68, 0.53);
              text-decoration: none;
              background-size: 0px 2px;
            }
          }
        }
        .Society_text {
          width: 100%;
          height: 170px;
          // border-bottom-left-radius: 4px;
          // border-bottom-right-radius: 4px;
          border-radius: 4px;
          color: #333333;
          background: #fff;

          .Society_text_content {
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            letter-spacing: 0px;
            padding: 20px;
            line-height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-bottom: 30px;
          }
          .more {
            padding: 0 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding-left: 20px;
            // width: 80px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #006eff;
            line-height: 22px;
            .date {
              color: rgba(0, 110, 255, 1);
              font-size: 24px;
              font-weight: 600;
              font-family: arial;
            }
          }
        }
      }
    }
  }
  .more_new {
    display: flex;
    flex-direction: row;
    padding: 10px 30px;
    color: #fff;
    border-radius: 5px;
    background: #00689d;
    width: fit-content;
    justify-content: center;
    align-items: center;
    margin: auto;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
  .noData {
    line-height: 60px;
    text-align: center;
    color: #999;
  }
  .Society_vedio_box {
    width: 100%;
    .tit_box {
      width: 100%;
      height: 229px;
      background: rgba(10, 16, 75, 1);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .tit {
        color: #fff;
        background: rgba(0, 87, 217, 1);
        width: 440px;
        height: 80px;
        font-size: 40px;
        line-height: 80px;
        text-align: center;
      }
    }
    .bottom {
      width: 1200px;
      margin: 50px auto 0px;
      padding-bottom: 40px;

      .bottom_box {
        display: flex;
        flex-direction: row;

        margin-right: 10px;
        height: 600px;

        .bottom_box_content:first-child {
          background: rgb(0, 104, 157);
        }
        .bottom_box_content:nth-child(2) {
          background: rgba(74, 159, 65, 1);
        }
        .bottom_box_content:last-child {
          background: rgb(252, 195, 11);
        }
        .bottom_box_content {
          cursor: pointer;
          width: 400px;
          height: 100%;
          border-radius: 4px;
          &:hover img {
            opacity: 0.5;
            transition: 0.8s ease;
            transform: scale(1.2, 1.2);
          }
          // box-shadow: 0px 6px 5px #ccc;
          .bottom_box_content_img_box {
            height: 264px;
            padding: 10px;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            .my-video {
              width: 100%;
              object-fit: cover;
            }
          }
          // img {
          //   object-fit: cover;
          //   width: 100%;
          //   height: 100%;
          //   padding: 18px;
          //   transition: 0.8s ease;
          // }
          video {
            width: 100%;
            height: 100%;
          }
          .date {
            margin-top: 20px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;

            border: 1px solid #fff;
            border-left: none;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            padding: 0 20px;
            p {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;
            }
            div {
              margin-top: 14px;
              font-size: 16px;
              color: #fff;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
  .list-item {
    // display: inline-block;
    // margin-right: 10px;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (max-width: 767px) {
  .NewList_society {
    width: 100%;
    // background: #d8d8d8;
    .Society_title {
      display: inline-block;
      margin: 40px 0 30px;
      color: #fff;
      padding: 10px 30px;
      background: #439f38;
    }
  }
  .Society_box {
    // width: 100%;
    padding: 0 10px 40px;
    margin: 10px auto 0;
    // margin-bottom: 40px;

    .Society_box_div {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      .Society_box_content:hover .p {
        background-size: 100% 2px !important;
      }
      .Society_box_content {
        width: 100%;
        // height: 617px;
        cursor: pointer;
        margin-bottom: 10px;

        .Society_img_box {
          position: relative;
          width: 100%;
          height: 300px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
            transition: 0.8s ease;
          }

          .title {
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            margin-top: 7px;
            font-size: 31px;
            color: #fff;
            margin-bottom: 8px;
            padding: 0 20px;
            position: absolute;
            bottom: 0;
            color: #fff;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 15px;
            z-index: 99;
            .p {
              background-image: linear-gradient(#fff, #fff);
              background-position: left bottom;
              background-repeat: no-repeat;
              transition: background-size 0.2s
                cubic-bezier(0.55, 0.085, 0.68, 0.53);
              text-decoration: none;
              background-size: 0px 2px;
            }
          }
        }
        .Society_text {
          width: 100%;
          height: 170px;
          // border-bottom-left-radius: 4px;
          // border-bottom-right-radius: 4px;
          border-radius: 4px;
          color: #333333;
          background: #fff;

          .Society_text_content {
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            letter-spacing: 0px;
            padding: 20px;
            line-height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-bottom: 30px;
          }
          .more {
            padding: 0 20px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            // padding-left: 20px;
            // width: 80px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #006eff;
            line-height: 22px;
            .date {
              color: rgba(0, 110, 255, 1);
              font-size: 24px;
              font-weight: 600;
              font-family: arial;
            }
          }
        }
      }
    }
  }
  .more_new {
    display: flex;
    flex-direction: row;
    padding: 10px 30px;
    color: #fff;
    border-radius: 5px;
    background: #00689d;
    width: fit-content;
    justify-content: center;
    align-items: center;
    margin: auto;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
  .noData {
    line-height: 60px;
    text-align: center;
    color: #999;
  }
  .Society_vedio_box {
    width: 100%;
    .tit_box {
      width: 100%;
      height: 149px;
      background: rgba(10, 16, 75, 1);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .tit {
        color: #fff;
        background: rgba(0, 87, 217, 1);
        width: 100%;
        height: 60px;
        font-size: 30px;
        line-height: 60px;
        text-align: center;
      }
    }
    .bottom {
      width: 100%;
      padding-bottom: 20px;
      .bottom_box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        // margin-right: 10px;
        // height: 600px;

        .bottom_box_content:first-child {
          background: rgb(0, 104, 157);
        }
        .bottom_box_content:nth-child(2) {
          background: rgba(74, 159, 65, 1);
        }
        .bottom_box_content:last-child {
          background: rgb(252, 195, 11);
        }
        .bottom_box_content {
          margin-top: 10px;
          cursor: pointer;
          width: 100%;
          height: 100%;
          border-radius: 4px;

          // box-shadow: 0px 6px 5px #ccc;
          .bottom_box_content_img_box {
            height: 364px;
            padding: 10px;
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
            .my-video {
              width: 100%;
              object-fit: cover;
            }
          }
          // img {
          //   object-fit: cover;
          //   width: 100%;
          //   height: 100%;
          //   padding: 18px;
          //   transition: 0.8s ease;
          // }
          video {
            width: 100%;
            height: 100%;
          }
          .date {
            margin-top: 20px;
            width: 138px;
            height: 32px;
            border-radius: 0px 4px 4px 0px;

            border: 1px solid #fff;
            border-left: none;
            font-size: 18px;
            font-family: Avenir-Medium, Avenir;
            font-weight: 500;
            color: #fff;
            line-height: 32px;
            text-align: center;
          }
          .content_test {
            padding: 20px 20px 40px;
            p {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              margin-top: 7px;
              font-size: 31px;
              color: #fff;
              margin-bottom: 8px;
            }
            div {
              margin-top: 14px;
              font-size: 16px;
              color: #fff;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
  .list-item {
    // display: inline-block;
    // margin-right: 10px;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(80px);
  }
  @-webkit-keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes twinkling {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>
